import React, { useState } from "react";
import styled from "@emotion/styled";

import {
  addSelectedPublication,
  deleteSelectedPublication,
} from "../../../redux/slices/populate";
import { Button, Typography } from "@mui/material";
import { ArrowOutward } from "@mui/icons-material";
import { RootState } from "../../../redux/store";
import useAppSelector from "../../../hooks/useAppSelector";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { Publication } from "../../../types/app";

const Container = styled.div<{ selected: boolean; canSelect: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin-top: 10px;
  border-radius: 17px;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? "#c2cdce" : "white")};

  &:hover {
    background-color: ${(props) => (props.canSelect ? "#d4dcdc" : "white")};
  }
`;

const SectionContainer = styled.div`
  display: flex;
  width: 100%;
`;

const Title = styled(Typography)`
  font-size: 15px;
  font-weight: bold;
  max-width: calc(100% - ${230}px);
`;

const Author = styled(Typography)`
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const VisitButton = styled(Button)`
  margin-left: 10px;
  margin-bottom: 2px;
  padding: 0px 8px;
  height: 22px;
  font-size: 12px;
`;

type Props = {
  publication: Publication;
  idx: number;
};

function canSelect(publication: Publication) {
  return (
    publication.ePrintUrl !== null &&
    (publication.ePrintUrl.includes(".pdf") ||
      publication.ePrintUrl.includes("sciencedirect"))
  );
}

function PopulateResultsCard(prop: Props) {
  const state = useAppSelector((state: RootState) => state.populate);
  const dispatch = useAppDispatch();
  const publication = prop.publication;
  console.log(publication.abstract);
  const abstract =
    ". . . " + publication.abstract.split("  ").join(" . . . ") + " . . .";

  const handleSelect = () => {
    if (state.selectedPublications.includes(prop.idx)) {
      dispatch(deleteSelectedPublication(prop.idx));
    } else if (canSelect(publication)) {
      dispatch(addSelectedPublication(prop.idx));
    }
  };

  return (
    <Container
      selected={state.selectedPublications.includes(prop.idx)}
      canSelect={canSelect(publication)}
      onClick={handleSelect}
    >
      <SectionContainer>
        <Title>{publication.title}</Title>
        <VisitButton
          variant="outlined"
          endIcon={<ArrowOutward />}
          onClick={() => window.open(publication.pubUrl, "_blank")}
        >
          Visit
        </VisitButton>
        {!canSelect(publication) && (
          <VisitButton variant="outlined" disabled>
            Unable to populate
          </VisitButton>
        )}
      </SectionContainer>
      <SectionContainer>
        {publication.abstract.length !== 0 && (
          <Author>{publication.authors.join(", ")}</Author>
        )}
        <Typography whiteSpace="pre">
          {publication.venue !== "NA" && ` - ${publication.venue}`}
        </Typography>
        <Typography whiteSpace="pre"> - {publication.pubYear}</Typography>
        {publication.numCitations !== 0 && (
          <Typography whiteSpace="pre">
            - Cited by: {publication.numCitations}
          </Typography>
        )}
      </SectionContainer>
      {publication.abstract.length !== 0 ? (
        <SectionContainer>{abstract}</SectionContainer>
      ) : (
        <SectionContainer>
          <Author>{publication.authors.join(", ")}</Author>
        </SectionContainer>
      )}
    </Container>
  );
}

export default PopulateResultsCard;
